export default __webpack_public_path__ + "static/media/most_innof.0af8524b.png";